function replyAuthorName(replyTo, participants = [], currentUserId) {
    const senderId = String(replyTo?.senderId?._id ?? replyTo?.senderId ?? replyTo?.sender?._id ?? '');
    if (currentUserId && senderId === String(currentUserId)) return 'Tú';

    const fromReply = replyTo?.sender;
    if (fromReply?.firstName || fromReply?.lastName) {
        return [fromReply.firstName, fromReply.lastName].filter(Boolean).join(' ');
    }

    const match = participants.find((u) => String(u._id ?? u.id) === senderId);
    if (match) {
        return [match.firstName, match.lastName].filter(Boolean).join(' ') || 'Usuario';
    }

    return 'Mensaje';
}

function replyPreviewText(replyTo) {
    if (!replyTo) return '';
    if (replyTo.type === 'image') return 'Foto';
    if (replyTo.type === 'file') {
        const name = replyTo.attachments?.[0]?.fileName;
        return name || 'Archivo';
    }
    if (replyTo.type === 'url') {
        const raw = (replyTo.content || '').trim();
        if (!raw) return 'Enlace';
        try {
            const host = new URL(/^https?:\/\//i.test(raw) ? raw : `https://${raw}`).hostname;
            return host.replace(/^www\./i, '');
        } catch {
            return 'Enlace';
        }
    }
    const text = (replyTo.content || '').replace(/\s+/g, ' ').trim();
    return text.length > 120 ? `${text.slice(0, 120)}…` : text;
}

/**
 * Vista previa de mensaje citado (dentro de burbuja o compositor).
 */
export function ChatReplyPreview({
    replyTo,
    participants = [],
    currentUserId,
    isOwn = false,
    variant = 'inline',
    onDismiss,
}) {
    if (!replyTo) return null;

    const author = replyAuthorName(replyTo, participants, currentUserId);
    const text = replyPreviewText(replyTo);

    const rootClass = [
        'chat-reply-preview',
        variant === 'composer' ? 'chat-reply-preview--composer' : 'chat-reply-preview--inline',
        isOwn ? 'chat-reply-preview--own' : '',
    ].filter(Boolean).join(' ');

    return (
        <div className={rootClass}>
            <span className="chat-reply-preview__bar" aria-hidden="true" />
            <div className="chat-reply-preview__body">
                {variant === 'composer' && (
                    <span className="chat-reply-preview__label">Respondiendo a</span>
                )}
                <span className="chat-reply-preview__author">{author}</span>
                {text && (
                    <span className="chat-reply-preview__text" title={text}>
                        {text}
                    </span>
                )}
            </div>
            {onDismiss && (
                <button
                    type="button"
                    onClick={onDismiss}
                    className="chat-reply-preview__dismiss"
                    aria-label="Cancelar respuesta"
                >
                    ×
                </button>
            )}
        </div>
    );
}

export { replyAuthorName, replyPreviewText };
